// extracted by mini-css-extract-plugin
export var note = "tip-module--note--+0c5G";
export var sbShowMain = "tip-module--sb-show-main--oCdMo";
export var wrapper = "tip-module--wrapper--EyJOH";